export const CART_LINE_QUANTITY_INCREASED_EVENT = 'cartLineQuantityIncreased';

export const GENDER_COOKIE_CHANGED_EVENT = 'genderCookieChanged';
